import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import HeroSlider from '../components/HeroSlider';
import HeroSliderSkeleton from '../components/HeroSliderSkeleton';
import UpcomingMovies from '../components/UpcomingMovies';
import UpcomingMoviesSkeleton from '../components/UpcomingMoviesSkeleton';
import BannerSection from '../components/BannerSection';
import BannerSectionSkeleton from '../components/BannerSectionSkeleton';
import LatestNews from '../components/LatestNews';
import LatestNewsSkeleton from '../components/LatestNewsSkeleton';
import FeaturedEvents from '../components/FeaturedEvents';
import FeaturedEventsSkeleton from '../components/FeaturedEventsSkeleton';
import VideoPhotos from '../components/VideoPhotos';
import VideoPhotosSkeleton from '../components/VideoPhotosSkeleton';
import Partners from '../components/Partners';
import PartnersSkeleton from '../components/PartnersSkeleton';
import axiosInstance from '../utils/axios';
import Contact from '../components/Contact';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    banners: [],
    banner_bg: {},
    upcoming_movies: [],
    now_playing: [],
    latest_video: {},
    latest_news: [],
    latest_events: [],
    latest_gallery: [],
    media_base_url: ""
  });
  const [partners, setPartners] = useState([]);

useEffect(() => {
  fetchData();
}, []);


  const fetchData = async () => {
    if (!navigator.onLine) {
      toast("Offline. Please check your connection and refresh.");
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const res = await Promise.race([
        axiosInstance.get("customer/home"),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 5000))
      ]);
      setData(res.data);

      const p = await Promise.race([
        axiosInstance.get("core/partner/"),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 5000))
      ]);
      setPartners(p.data);
    } catch (e) {
      console.error('Home fetch error:', e);
      toast.error(`Failed to load data: ${e.response?.status || 'Network Error'}. Please refresh.`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <main>
      {loading ? (
        <>
          <HeroSliderSkeleton />
          <div id="upcoming-movies">
            <UpcomingMoviesSkeleton />
          </div>
          <BannerSectionSkeleton />
          <div id="latest-news">
            <LatestNewsSkeleton />
          </div>
          <div id="featured-events">
            <FeaturedEventsSkeleton />
          </div>
          <div id="video-photos">
            <VideoPhotosSkeleton />
          </div>
          <PartnersSkeleton />
          <div id="contact">
            <Contact />
          </div>
        </>
      ) : (
        <>
          <HeroSlider bannerBG={data.banner_bg} banners={data.banners} />
          {(data.upcoming_movies.length > 0 || data.now_playing.length > 0) && (
            <div id="upcoming-movies">
              <UpcomingMovies uMovies={data.upcoming_movies} nMovies={data.now_playing} />
            </div>
          )}
          {data.latest_video && Object.keys(data.latest_video).length > 0 && (
            <BannerSection video={data.latest_video} />
          )}
          {data.latest_news.length > 0 && (
            <div id="latest-news">
              <LatestNews news={data.latest_news} />
            </div>
          )}
          {data.latest_events.length > 0 && (
            <div id="featured-events">
              <FeaturedEvents events={data.latest_events} />
            </div>
          )}
          {data.latest_gallery.length > 0 && (
            <div id="video-photos">
              <VideoPhotos gallery={data.latest_gallery} />
            </div>
          )}
          {partners?.partners?.length > 0 && (
            <Partners partners={partners.partners} />
          )}
          <div id="contact">
            <Contact />
          </div>
        </>
      )}

      {/* Other components go here */}
      <ToastContainer />
    </main>
  );
};

export default Home;
